import { MenuItemStyles } from 'react-pro-sidebar/dist/components/Menu';
import styled, { CSSObject } from 'styled-components';

export const StyledAsideMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
`;

export const StyledLogoContainer = styled.div`
  padding-top: 1em;
  padding-bottom: 1em;
  text-align: center;
  max-width: 80px;

  svg {
    filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
    cursor: pointer;
  }
`;

export const StyledCollapseContainer = styled.div`
  padding-top: 1em;
  padding-bottom: 1em;
  margin-bottom: 1em;
  text-align: center;
  max-width: 80px;
  cursor: pointer;
  color: rgb(134, 213, 255);

  &:hover {
    color: white;
  }
`;

export const menuStyles: MenuItemStyles = {
  button: {
    color: 'rgb(134, 213, 255)',
    [`&.active`]: {
      backgroundColor: 'rgb(6, 85, 200)',
      color: '#ffffff',
    },
    [`&.ps-active`]: {
      backgroundColor: 'rgb(6, 85, 200)',
      color: '#ffffff',
      ['&:hover']: {
        backgroundColor: 'rgb(6, 85, 200)',
      },
    },
    [`&:hover`]: {
      color: '#ffffff',
      backgroundColor: 'unset',
      [`.tooltip`]: {
        visibility: 'visible',
        transitionDelay: '0.5s',
        top: '35px',
        left: '25px',
      },
    },
  },
  label: {
    whiteSpace: 'normal',
  },
};

export const sidebarRootStyles: CSSObject = {
  backgroundColor: 'rgb(32, 111, 226)',
  [`.ps-sidebar-container`]: {
    zIndex: 'initial',
    overflowY: 'unset',
    overflowX: 'unset',
    backdropFilter: 'blur(2px)',
    backgroundColor: 'unset',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
};
